import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/vercel/path0/app/(auth)/forgot-password/forgot-password-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
